<script>
  import { _ } from 'svelte-i18n'
  import Body from '/Groups/Body'
  import Link from '/Atoms/Link'
  import { formatDate } from '/helper'

  export let project
  export let events

  const sideWidgets = project?.relatedWidgets || []
  const chatLink = sideWidgets?.[0]?.links?.[1]?.linkUrl

  const enableTimelapse = window?.location?.hash == "#timelapse"

  let groupedEvents = {}
  let featuredEvent = null
  let now = Date.now()
  let counter = 0
  setInterval(() => {
    now = Date.now() + (enableTimelapse ? (counter++ * 1000 * 60 *15 ) : 0) // simulate time passing
  }, enableTimelapse? 100 : 10000)

  $: {

    // enrich events
    events = events.map(event => {
      const dayAtStart = new Date(event.eventDates[0].startDateAndTime).setHours(0,0,0,0);
      const timeToStart = new Date(event.eventDates[0].startDateAndTime).getTime() - now
      const timeToEnd = new Date(event.eventDates[0].endDateAndTime).getTime() - now
      const daysTillStart = Math.ceil((dayAtStart - now) / (1000 * 60 * 60 * 24))
      let label = null
      let listLabel = null
      if (timeToStart > 0) {
        if (daysTillStart < 1) {
          label = $_('stream.today')
        } else {
          label = $_('stream.in') + " " + daysTillStart + " " + ( daysTillStart == 1 ? $_('stream.day') : $_('stream.days'))
        }
      } else if (timeToEnd > 0) {
        label = $_('stream.live_now')
      }
      if (daysTillStart == 0 ) {
        listLabel = $_('stream.today')
      }
      return {
        ...event,
        timeToStart,
        timeToEnd,
        label,
        listLabel
      }
    })

    // remove yesterday's events
    events = events.filter(event => {
      const dayAtStart = new Date(event.eventDates[0].startDateAndTime).setHours(0,0,0,0);
      const today = new Date(now).setHours(0,0,0,0);
      return dayAtStart >= today
    })

    // events grouped by date
    groupedEvents = events.reduce((acc, event) => {
      const start = new Date((event?.eventDates || [])[0].startDateAndTime)
      const date = $_('stream.day.'+ start.getDay()) + ", " + formatDate(start, "event-day-month")
      if (!acc[date]) {
        acc[date] = []
      }
      acc[date].push(event)
      return acc
    }, {})

    // featured event
    featuredEvent = null
    const timetoEnd = 9999999999999
    for (let event of events) {
      if (event.timeToEnd > 0 && event.timeToEnd < timetoEnd) {
        featuredEvent = event
        break
      }
    }
  }

  function getRelatedPeople(event) {
    const pplString = event?.relatedPeople?.[0]?.members?.map(m => m.title).join (", ")
    if (pplString) {
      return $_('stream.with') + " " + pplString
    }
    return ""
  }

</script>

<div class="container">

  <section class="main">
    <!--
    {new Date(now).toLocaleString()}
    -->

    <h1 class="headline-livestream">
      Livestream
    </h1>

    {#if enableTimelapse}
      Now: {formatDate(new Date(now), 'livestream-featured')}<br />
    {/if}

    <section class="stream">
      <div style='padding:56.25% 0 0 0;position:relative;'>
        <iframe title="stream"
          src='https://live.serve-u.de/tm22.html'
          allowfullscreen
          frameborder='0'
          style='position:absolute;top:0;left:0;width:100%;height:100%;'>
        </iframe>
      </div>
    </section>

    <!--
      {JSON.stringify(featuredEvent)}
    -->
    
    {#if featuredEvent}
      <div class="featured">
        <span class="type">
          {(featuredEvent?.eventformat || []).map( f => f.toUpperCase()).join(", ")}
        </span>
        <h3 class="title">
          {featuredEvent.title}
        </h3>
        <p class="people">
          {getRelatedPeople(featuredEvent)}
        </p>
        <span class="time">
          {#each (featuredEvent?.eventDates || []) as date}
            {$_('stream.day.'+ new Date(date.startDateAndTime).getDay())},
            {formatDate(new Date(date.startDateAndTime), 'livestream-featured')}
          {/each}
        </span>
        {#if featuredEvent.label}
          <div class="label">
            {featuredEvent.label}
          </div>
        {/if}

        <a class="chat" href={chatLink} target="_blank">{$_('stream.button.chat')}</a>
        <a class="chat" href={$_('stream.button.captions.url')} target="_blank">{$_('stream.button.captions.text')}</a>

        {#if featuredEvent?.body && featuredEvent?.body.length > 0}
          {#key featuredEvent}
            <div class="body">
              <Body body={featuredEvent?.body || []} />
            </div>
          {/key}
        {/if}

      </div>

    {/if}

    {#each Object.entries(groupedEvents) as day}
      <h2 class="day">
        {day[0]}
      </h2>
      <div class="dayEvents">
        {#each day[1] as event}
          <div class="event">
            <Link slug={event.slug} section="events">
              <span class="time">
                {#each (event?.eventDates || []) as date}
                  {formatDate(new Date(date.startDateAndTime), 'time24')}
                {/each}
              </span>
              <span class="type">
                {(event?.eventformat || []).map( f => f.toUpperCase()).join(", ")}
              </span>
              <h3 class="title">
                {event.title}
              </h3>
              <p class="people">
                {getRelatedPeople(event)}
              </p>
            </Link>
            {#if event.listLabel}
              <div class="label">
                {event.listLabel}
              </div>
            {/if}
          </div>
        {/each}
      </div>
    {/each}

  </section>

</div>

<style lang="scss">
  /*.overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0);
    z-index: -1;
  }*/

  .main {
    max-width: 820px;
    margin: auto;
  }

  .container {
    // background: black;
    color: white;
    text-align: center;
    @include grid-padding;
  }
  .headline-livestream {
    @include typo-serif-small-caps-28;
    color: $color-red;
    margin-bottom: 42px;
  }
  .stream {
    margin-bottom: 27px;
  }
  .featured {
    margin-bottom: 82px;
  }
  .day {
    @include typo-serif-title-44;
    margin-bottom: 32px;
  }

  .event {
    @include typo-serif-text-28;
    margin-bottom: 32px;

    .type:not(:empty):before {
      content: "• ";
      position: relative;
      top: 0.4ex;
    }
  }

  .type, .event .time {
    @include typo-serif-small-caps-28;
  }

  .title {
    font-style: italic;
  }

  .label {
    color: $color-mint;
  }

  .dayEvents {
    margin-bottom: 61px;
  }

  .chat {
    //@include typo-grotesk-text-24;
    //@include media-large-and-less { // breaks at unusual breakpoint
      @include typo-grotesk-text-24-small;
    //}
    box-sizing: border-box;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border: 1px solid  white;
    position: relative;
    top: 2px;

    //height: 40px;
    //border-radius: 20px;
    padding: 0.3ex 1ex 0 1ex;
    //@include media-large-and-less { // breaks at unusual breakpoint
      height: 34px;
      border-radius: 17px;
    //}
    
    margin-right: 0.2em;
    user-select: none;
    margin-top: 24px;
  }

  .body {
    margin-top: 24px;
  }

</style>